module.exports = __webpack_public_path__ + "img/HTML_and_Semantics_Building_Meaningful_Web_Content.28994db7.jpeg";